import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import * as moment from "moment";
import * as ko from "knockout";
import baoRouter from "../../services/bao-router";
import BaoDialog from "./../../factories/bao-dialog";

// This class is used for the Reports "JobOccupation1BlockReport" and "JobOccupation2BlockReport"
class JobOccupationReport {

    Bao = Bao;
    TabPage: Factories.TabPage;
    Parent;
    PageSize = ko.observable(0);
    TotalRows = ko.observable(0);
    PageIndex = ko.observable(0);
    StartDateTime = ko.observable('');
    EndDateTime = ko.observable('');
    ShiftGroupId = ko.observable('');
    ShiftGroupName = ko.observable('');
    ShiftBookId: KnockoutObservableArray<string> = ko.observableArray([]);
    ShiftBookName = ko.observable('');
    ShiftBook: KnockoutObservableArray<string> = ko.observableArray([]);
    Calendar = ko.observableArray([]);
    JobOccupationCollection = ko.observableArray([]);
    ResultCollection = ko.observableArray([]);
    ResultCollection2 = ko.observableArray([]);
    IsReportResultEmpty = ko.observable(false);
    ReportHTML = ko.observable<HTMLElement>();
    LastRowCellHTML = ko.observable<HTMLElement>();
    AbsentCellHTML = ko.observable<HTMLElement>();
    FromDailyShiftPlan = ko.observable(false);
    ShiftbookIdsStringifiedForCustomFilter: KnockoutObservable<string> = ko.observable("");
    radioDataSource = ko.observable("ShiftplanQualification");
    RemoveShiftbookGroup = ko.observable(false);
    DisplayView: KnockoutObservable<string> = ko.observable('horizontal');
    SidebarTop: KnockoutObservable<string> = ko.observable('0');
    HeaderLeft: KnockoutObservable<string> = ko.observable('0');

    SearcherShiftBook: any;

    SearcherShiftGroup: Bindings.baoSearcher = {
        ObjectId: this.ShiftGroupId,
        ObjectValue: 'Name',
        SearchType: 'ShiftGroup',
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { ShiftbookIds: this.ShiftbookIdsStringifiedForCustomFilter }
    };

    constructor(parent: any, params: any) {
        this.Parent = parent;
        this.Parent.FormReportId.subscribe(() => {
            this.beforeClose();
        });
        this.SearcherShiftBook = {
            SearchType: 'ShiftBook',
            ObjectId: this.ShiftBookId,
            ObjectValue: 'Name',
            AutoComplete: true,
            AutoSearch: true,
            MultiSelect: true,
            Items: this.ShiftBook,
            CustomFilter: { ShiftbookTypeId: '1AB743AA-C33C-4DB9-8920-3C8E79B501E3' }
        };
        this.ShiftBookId.subscribe(() => {
            this.ShiftbookIdsStringifiedForCustomFilter(JSON.stringify(this.ShiftBookId()));
        });

        if (params) {
            if (params.ShiftBookId) {
                this.ShiftBookId(params.ShiftBookId);
                this.ShiftBookName(params.ShiftBookName);
            }
            if (params.ShiftGroupId) {
                this.ShiftGroupId(params.ShiftGroupId);
                this.ShiftGroupName(params.ShiftGroupName);
            }
            if (params.FromDate) {
                this.StartDateTime(params.FromDate);
            }
            if (params.ToDate) {
                this.EndDateTime(params.ToDate);
            }
        }

        this.TabPage = parent.TabPage;

        this.TabPage.IsActiveTab.subscribe(() => {
            if (this.TabPage.IsActiveTab()) {
                this.recalcSchedulePosition();
                this.recalcScroll();
            }
        });
        this.LastRowCellHTML.subscribe(() => {
            $(this.AbsentCellHTML()).height($(this.LastRowCellHTML()).height());
        });
        this.ShiftBook.subscribe(() => {
            this.ShiftGroupId('');
            this.ShiftGroupName('');
        });
    }

    loaded() {
        this.TabPage.IsLoading(true);
        $(this.ReportHTML()).parents(".col-lg-12").eq(1).find("select.form-control").eq(0).css({ "position": "fixed", "width": "65.7%", "z-index": "500" });
        window.addEventListener('scroll', this.ScrollEventHandler);
        window.addEventListener('resize', this.ResizeEventHandler);
        this.recalcSchedulePosition();
        this.recalcScroll();
        this.getMetaDataFromServer();
    }

    Display = (isInInit: boolean) => {

        if (!this.IsValidDateFields()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }
        if (this.checkFilters(isInInit)) {
            this.TabPage.IsLoading(true);
            this.getDataFromServer().then(data => {
                this.ResultCollection(data.ResultCollection);
                this.recalcScroll();
                this.TabPage.IsLoading(false);
            });
        }
    }
    // Download Excel
    Download = () => {
        var filterobjects = ["ShiftGroupId", "ShiftBookId", "StartDateTime", "EndDateTime"];
        var data = {
            filter: this.Parent.GetFilterHashObject(filterobjects, this),
        };
        if (!this.checkFilters(false)) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return;
        }
        if (!this.IsValidDateFields()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }
        this.TabPage.IsLoading(true);
        Bao.post("ReportCenter/GetDownload" + "JobOccupationReport", JSON.stringify({
            shiftbookId: this.ShiftBookId(),
            shiftgroupId: this.ShiftGroupId(),
            startDate: this.StartDateTime(),
            endDate: this.EndDateTime(),
            dataSource: this.radioDataSource(),
            removeShiftBookGroup: this.RemoveShiftbookGroup(),
            display: this.DisplayView()
        })).then(result => {
            this.TabPage.IsLoading(false);
            if (result && result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            } else {
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }

    IsValidDateFields = () => {
         return Boolean(Bao.Utils.String.IsNullOrEmpty(this.StartDateTime()) || Bao.Utils.String.IsNullOrEmpty(this.EndDateTime()) || Number(this.EndDateTime()) >= Number(this.StartDateTime()));
    };

    //PDF 1Block Report
    DownloadPDF1Block = (isInInit: boolean) => {

        if (!this.IsValidDateFields()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }

        if (!this.checkFilters(isInInit)) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return;
        }

        this.TabPage.IsLoading(true);
        Bao.post("ReportCenter/GetDownloadPersonnelPlanningReport1Block", JSON.stringify({
            shiftbookId: this.ShiftBookId(),
            shiftgroupId: this.ShiftGroupId(),
            startDate: this.StartDateTime(),
            endDate: this.EndDateTime(),
            dataSource: this.radioDataSource(),
            removeShiftBookGroup: this.RemoveShiftbookGroup()
        })).then(result => {
            this.TabPage.IsLoading(false);
            if (result && result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            } else {
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
    //PDF 2Block Report
    DownloadPDF2Block = (isInInit: boolean) => {

        if (!this.IsValidDateFields()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }

        if (!this.checkFilters(isInInit)) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return;
        }

        this.TabPage.IsLoading(true);
        Bao.post("ReportCenter/GetDownloadPersonnelPlanningReport2Block", JSON.stringify({
            shiftbookId: this.ShiftBookId(),
            shiftgroupId: this.ShiftGroupId(),
            startDate: this.StartDateTime(),
            endDate: this.EndDateTime(),
            dataSource: this.radioDataSource(),
            removeShiftBookGroup: this.RemoveShiftbookGroup()
        })).then(result => {
            this.TabPage.IsLoading(false);
            if (result && result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            } else {
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }

    private checkFilters(isInInit: boolean): boolean {
        var completed = true;
        if (!this.ShiftGroupId() || !this.ShiftBookId() || !this.StartDateTime() || !this.EndDateTime()) {
            completed = false;
        }
        if (!completed && !(isInInit == true)) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }

    private getMetaDataFromServer() {
        return Bao.post("ReportCenter/GetJobOccupationMetaData", JSON.stringify({
            shiftBookId: this.ShiftBookId(),
            shiftGroupId: this.ShiftGroupId()
        })).then(result => {
            if (result.ByUserProfile === true) {
                //if (!this.ShiftBookId()) {
                this.ShiftBookId(result.shiftbookIds);
                this.ShiftBookName(result.shiftbookNames);
                this.RemoveShiftbookGroup(result.RemoveShiftbookGroup);
                //}
                if (!this.ShiftGroupId()) {
                    this.ShiftGroupId(result.ShiftGroupId);
                    this.ShiftGroupName(result.ShiftGroupName);
                }
                if (!this.StartDateTime()) {
                    this.StartDateTime(result.StartDateTime);
                }
                if (!this.EndDateTime()) {
                    this.EndDateTime(result.EndDateTime);
                }

                this.TabPage.IsLoading(false);
                this.Display(true);
            }
            else{
                //if (!this.ShiftBookId()) {
            this.ShiftBookId(result.ShiftBookId);
            this.ShiftBookName(result.ShiftBookName);
            //}
            if (!this.ShiftGroupId()) {
                this.ShiftGroupId(result.ShiftGroupId);
                this.ShiftGroupName(result.ShiftGroupName);
            }
            if (!this.StartDateTime()) {
                this.StartDateTime(result.StartDateTime);
            }
            if (!this.EndDateTime()) {
                this.EndDateTime(result.EndDateTime);
            }
            this.TabPage.IsLoading(false);
            this.Display(true);
            }
            
        });
    }

    private getDataFromServer() {
        return Bao.post("ReportCenter/GetJobOccupationModel", JSON.stringify({
            shiftGroupId: this.ShiftGroupId(),
            shiftBookId: this.ShiftBookId(),
            startDate: this.StartDateTime(),
            endDate: this.EndDateTime(),
            dataSource: this.radioDataSource(),
            removeShiftBookGroup: this.RemoveShiftbookGroup()
        }));
    }

    private recalcScroll() {
        //this.SidebarTop($(this.ReportHTML()).find("#content")[0]?.getBoundingClientRect().top + 'px');
        this.HeaderLeft(-window.pageXOffset + 'px');
    }

    private recalcSchedulePosition() {
        $(this.ReportHTML()).find(".job-occupation-table").css("top", $(this.ReportHTML()).find(".filters").height() + 33);
    }

    private ResizeEventHandler = (e) => {
        this.recalcSchedulePosition();
        this.recalcScroll();
    }

    private ScrollEventHandler = (e) => {
        e.preventDefault();
        this.recalcScroll();
    }

    private beforeClose() {
        // remove the eventlistener
        window.removeEventListener('scroll', this.ScrollEventHandler);
        window.removeEventListener('resize', this.ResizeEventHandler);
        $(this.ReportHTML()).parents(".col-lg-12").eq(1).find("select.form-control").eq(0).css({ "position": "static", "width": "100%", "z-index": "inherit" });
    }
}
export default JobOccupationReport;
